import React, { Component } from 'react';
import {
  Link, Route
} from 'react-router-dom';

import './css/sidebar.css';

export default class SideBar extends Component {

  constructor(props) {
    super(props);

    this.routes = {
      '/dashboard': {
        title: 'Dashboard',
        icon: "fa-tachometer"
      },
      '/apps': {
        title: "Apps",
        icon: "fa-tablet"
      },
      '/docs': {
        title: "Docs",
        icon: "fa-folder-open"
      },
      '/billing': {
        title: 'Billing',
        icon: 'fa-money'
      }
    };
  }
  
  render() {
    return (
      <div className="sidebar">
        <div className="sidebar-wrapper">
          <div className="logo">
            <a href="http://appbid.com">
              <img src="/assets/img/logo-light.svg"/>
            </a>
          </div>

          <ul>
            {Object.entries(this.routes).map(([path, route], idx) => (
              <Route
                 key={idx}
                 path={path}
                children= {({match, location}) => {
                  // root is dashboard hack
                  if (location.pathname == '/' && path == '/dashboard') {
                    match = true;
                  }
                  return (
                   <li key={idx}
                     className={match ? "active": ""}>
                     <Link to={path}>
                       <span>
                         <i className=
                            {"fa "+route.icon}></i>
                       </span>
                       {route.title}
                     </Link>
                   </li>
                  );
                }}
                />
            ))}
      
        <li>
        </li>

          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sidebar.js